const candles = `
syntax = "proto3";
package binary;
option go_package = "/pkg-bin/storage";
import "pairSwap.proto";
import "directSwap.proto";
import "trade.proto";
message Candle {
  double Open = 1;
  double Low = 2;
  double High = 3;
  int32 Date = 4;
  double Close = 5;
}
message BlockLite {
  string Network = 1;
  uint64 Date = 2;
  repeated Trade Trades = 3;
  repeated PairSwap PairSwaps = 4;
  repeated DirectSwap DirectSwaps = 5;
}
message Volume {
  bytes VolumeA = 1;
  bytes VolumeB = 2;
  double VolumeUSD = 3;
}
message Candles {
  repeated Candle Candle = 1;
  Volume Volume = 2;
}`;

const cexBalanceUpdate = `
syntax = "proto3";
package binary;
option go_package = "/pkg-bin/storage";
enum Exchange {
    UNDEFINED_EXCHANGE = 0;
    BINANCE = 1;
    GATE = 2;
}
message Balance {
    string coin = 1;
    double total = 2;
    double available = 3;
    Exchange exchange = 4;
}`;

const cexOrderUpdate = `
syntax = "proto3";
package binary;
option go_package = "/pkg-bin/storage";
enum Exchange {
    UNDEFINED_EXCHANGE = 0;
    BINANCE = 1;
    GATE = 2;
}
enum OrderType {
    UNDEFINED_TYPE = 0;
    MARKET = 1;
    LIMIT = 2;
}
enum OrderSide {
    UNDEFINED_SIDE = 0;
    BYU = 1;
    SELL = 2;
}
enum OrderStatus {
    UNDEFINED = 0;
    OPEN = 1;
    FILLED = 2;
    PARTIAL_FILLED = 3;
    CANCEL = 4;
    PARTIAL_CANCEL = 5;
    FAILED = 6;
}
message OrderState {
    OrderStatus status = 1;
    double priceAvg = 2;
    double fillBaseAmount = 3;
    double fillQuoteAmount = 4;
    double fee = 5;
    int64  created_at = 6;
    int64 updated_at = 7;
    int64 closed_at = 8;
}
message CreateRequest {
    string uuid = 1;
    string wallet = 2;
    Exchange exchange = 3;
    string pair = 4;
    OrderType type = 5;
    OrderSide side = 6;
    double price = 7;
    double  base_amount = 8;
    double  quote_amount = 9;
}
message Order{
    CreateRequest create = 1;
    OrderState state = 2;
}`;

const cexPriceUpdate = `
syntax = "proto3";
package binary;
option go_package = "/pkg-bin/storage";
message CexPriceUpdate {
    string   Price = 1;
    double   BaseVolume = 2;
    double   QuoteVolume = 3;
}`;

const directSwap = `
syntax = "proto3";
package binary;
option go_package = "/pkg-bin/storage";
message DirectSwap{
  string Tx = 1;
  int64  Date = 2;
  string Chain = 3;
  uint64 BlockNumber = 4;
  string Protocol = 5;
  string SrcToken = 6;
  string DstToken = 7;
  bytes Amount0 = 8;
  bytes Amount1 = 9;
  string  PriceA = 10;
  string  PriceAUSD = 11;
  string  PriceB = 12;
  string  PriceBUSD = 13;
  string  Wallet = 14;
  uint32  Order = 15;
  string  ValueUSD = 16;
}`;

const extendedTrade = `
syntax = "proto3";
package binary;
option go_package = "/pkg-bin/storage";
message TradesBlock {
  repeated Trade Trades = 1;
}
message Trade {
    string Tx = 1;
    int64 Date = 2;
    int64 Timestamp = 3;
    string Chain = 4;
    uint64 Blocknumber = 5;
    string Pair = 6;
    string Amount0 = 7;
    string Amount1 = 8;
    bool Buy = 9;
    float PriceA = 10;
    float PriceAUSD = 11;
    float PriceB = 12;
    float PriceBUSD = 13;
    bool Bot = 14;
    string Wallet = 15;
    int32 Order = 16;
    float ValueUsd = 17;
    uint64 Ticker = 18;
}`;

const pairSwap = `
syntax = "proto3";
package binary;
option go_package = "/pkg-bin/storage";
message PairSwap {
  string Tx = 1;
  int64  Date = 2;
  string Chain = 3;
  uint64 BlockNumber = 4;
  string Pair = 5;
  bytes Amount0 = 6;
  bytes Amount1 = 7;
  bool Buy =8;
  string  PriceA = 9;
  string  PriceAUSD = 10;
  string  PriceB = 11;
  string  PriceBUSD = 12;
  bool Bot= 13;
  string  Wallet = 14;
  uint32  Order = 15;
  string  ValueUSD = 16;
}`;

const trade = `
syntax = "proto3";
package binary;
option go_package = "/pkg-bin/storage";
message Trade {
    string   Pair = 1;
    double   PriceA = 2;
    double   PriceB = 3;
    double   PriceAUSD = 4;
    double   PriceBUSD = 5;
    bytes    VolumeA = 6;
    bytes    VolumeB = 7;
    double   VolumeUSD = 8;
    bool     IsBuy = 9;
}`;

const protoStrings: Record<string, string> = {
  candles,
  cexBalanceUpdate,
  cexOrderUpdate,
  cexPriceUpdate,
  directSwap,
  extendedTrade,
  pairSwap,
  trade,
};

export default protoStrings;
